import useMountEffect from '@restart/hooks/useMountEffect';
import { useNavigate } from 'react-router-dom';

import API, { setAuthToken } from '@/helpers/API';

const Page = () => {
  const navigate = useNavigate();

  useMountEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');

    if (!code) {
      navigate('/', { replace: true });
      return;
    }

    const redirectUri = window.location.origin + window.location.pathname;

    API.post('/auth/token', { code, redirectUri, clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID }).then(
      ({ success, data }) => {
        if (success && data?.access_token) {
          setAuthToken(data.access_token);
        }
        navigate('/', { replace: true });
    });
  });

  return null;
};

export default Page;
